
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/contato",
      function () {
        return require("private-next-pages/home/contato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/contato"])
      });
    }
  